import { Badge } from 'reactstrap';
import { faBolt, faList, faWrench } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const FeatureBadge = () => (
    <Badge className="primary">
        <FontAwesomeIcon
            icon={faBolt}
            className="mr-1"
        />

        <span>Feature</span>
    </Badge>
);

export const NewFieldBadge = () => (
    <Badge className="warning">
        <FontAwesomeIcon
            icon={faList}
            className="mr-1"
        />

        <span>Added Field</span>
    </Badge>
);

export const SettingBadge = () => (
    <Badge className="dark">
        <FontAwesomeIcon
            icon={faWrench}
            className="mr-1"
        />

        <span>Setting</span>
    </Badge>
);